<template>
  <section>
    <div class="column">
      <h1 class="section-head">สิทธิ์การเข้าถึง</h1>
      <nav class="level">
        <div class="level-left">
          <div class="level-item">
            <router-link class="button is-danger is-pulled-left" to="/permission"><i class="fas fa-arrow-left"></i>Back</router-link>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <div class="buttons">
              <button class="button is-success is-pulled-right" @click="submit"><i class="fas fa-clipboard-list"></i>บันทึก</button>
            </div>
          </div>
        </div>
      </nav>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Parent</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control ">
              <input name="group" class="input " type="text" placeholder="Parent" v-model="permission.name" disabled="disabled">
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Permision Name</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control">
              <input name="group" class="input " type="text" placeholder="Permision Name" v-model="permissionData.name" v-validate="'required|min:4|max:35'">
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Permision Slug</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control">
              <input name="group" class="input " type="text" placeholder="Permision Slug" v-model="permissionData.slug" v-validate="'required|min:4|max:35'">
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  
</template>

<script>
import Request from '@/libraries/request';
import PermissionModel from '@/model/permission_model'


  export default {

    
    data() {
      return {
        permission: {
            id: null,
            name: '',
            slug: '',
            parent_id: 0,
        },
        permissionData: {
            id: null,
            name: '',
            slug: '',
            parent_id: 0,
        },
        isLoading: true,
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      async init(){
        this.permission = await PermissionModel.get_permission(this.$route.params.id);
        this.permission = this.permission[0];
        this.isTableLoading = false;
        this.isLoading = false;
      },
      submit(){
        this.isLoading = true;
        let data = {
          id: this.permissionData.id,
          name: this.permissionData.name,
          slug: this.permissionData.slug,
          parent_id: this.permission.id,
        }
        Request.post('permissions/add',data, (res) => {
          if(res.data.status){
            this.isLoading = false;
            this.$buefy.snackbar.open('บันทึกสำเร็จ!');
            this.$router.push('/permission');
          }else{
            this.$buefy.toast.open('ไม่สามารถบันทึกได้! - ' + res.data.msg);
          }
        });
        this.isLoading = false;
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Permission/add.vue